export const allProducts = [
  // Beauty Products
  {
    id: 1,
    name: "Luxury Skincare Set",
    price: 329,
    originalPrice: 549,
    image: "https://readdy.ai/api/search-image?query=Elegant%20luxury%20skincare%20cream%20jars%20and%20bottles%20with%20gold%20accents%20arranged%20on%20clean%20white%20marble%20surface%20with%20soft%20pink%20lighting%20and%20delicate%20flower%20petals%20showcasing%20premium%20beauty%20cosmetics%20collection&width=400&height=400&seq=prod1beauty&orientation=squarish",
    category: "beauty",
    badge: "HOT",
    description: "Complete luxury skincare collection with vitamin C serum, hyaluronic acid moisturizer, and night cream for radiant glowing skin. Dermatologist tested and suitable for all skin types.",
    rating: 4.9,
    reviews: 312,
    specs: { "Volume": "150ml each", "Skin Type": "All Types", "Ingredients": "Vitamin C, Hyaluronic Acid", "Shelf Life": "24 months", "Origin": "South Korea" }
  },
  {
    id: 2,
    name: "LED Vanity Mirror Pro",
    price: 219,
    originalPrice: 329,
    image: "https://readdy.ai/api/search-image?query=Modern%20LED%20vanity%20mirror%20with%20bright%20adjustable%20lighting%20and%20elegant%20white%20frame%20on%20clean%20minimalist%20surface%20showcasing%20beauty%20accessory%20design%20with%20perfect%20illumination&width=400&height=400&seq=prod2beauty&orientation=squarish",
    category: "beauty",
    badge: "SALE",
    description: "Professional LED mirror with adjustable brightness, touch controls, and 3 color modes for perfect makeup application. 10x magnification on one side.",
    rating: 4.7,
    reviews: 189,
    specs: { "Size": "30cm x 40cm", "Lighting": "LED, 3 modes", "Magnification": "1x / 10x", "Power": "USB-C", "Color": "Rose Gold" }
  },
  {
    id: 3,
    name: "Premium Makeup Brush Set",
    price: 185,
    originalPrice: 289,
    image: "https://readdy.ai/api/search-image?query=Professional%20makeup%20brush%20set%20with%20soft%20bristles%20and%20elegant%20rose%20gold%20handles%20displayed%20in%20luxury%20case%20on%20white%20marble%20surface%20with%20beauty%20cosmetics%20background&width=400&height=400&seq=prod3beauty&orientation=squarish",
    category: "beauty",
    badge: "NEW",
    description: "12-piece professional makeup brush set with ultra-soft synthetic bristles and premium rose gold handles. Includes foundation, contour, blush, and eye brushes.",
    rating: 4.8,
    reviews: 245,
    specs: { "Pieces": "12", "Material": "Synthetic Bristles", "Handle": "Rose Gold Aluminum", "Case": "Included", "Vegan": "Yes" }
  },
  {
    id: 4,
    name: "Jade Facial Roller Set",
    price: 129,
    originalPrice: 199,
    image: "https://readdy.ai/api/search-image?query=Natural%20jade%20stone%20facial%20roller%20and%20gua%20sha%20tools%20on%20white%20marble%20surface%20with%20fresh%20green%20leaves%20and%20spa%20aesthetic%20showing%20wellness%20beauty%20accessories&width=400&height=400&seq=prod4beauty&orientation=squarish",
    category: "beauty",
    badge: "HOT",
    description: "Natural jade stone facial roller for lymphatic drainage, reduces puffiness, and promotes youthful glowing skin. Includes gua sha tool.",
    rating: 4.6,
    reviews: 178,
    specs: { "Material": "Natural Jade", "Includes": "Roller + Gua Sha", "Size": "Standard", "Cooling": "Yes", "Cruelty-Free": "Yes" }
  },
  {
    id: 5,
    name: "Vitamin C Brightening Serum",
    price: 149,
    originalPrice: 229,
    image: "https://readdy.ai/api/search-image?query=Premium%20vitamin%20C%20brightening%20serum%20bottle%20with%20orange%20packaging%20and%20dropper%20on%20white%20marble%20surface%20with%20citrus%20fruits%20and%20clean%20minimalist%20beauty%20product%20photography&width=400&height=400&seq=prod5beauty&orientation=squarish",
    category: "beauty",
    badge: "NEW",
    description: "20% Vitamin C serum with ferulic acid and vitamin E for maximum antioxidant protection. Brightens, firms, and evens skin tone.",
    rating: 4.9,
    reviews: 421,
    specs: { "Vitamin C": "20%", "Volume": "30ml", "Skin Type": "All Types", "Fragrance": "Free", "Paraben": "Free" }
  },

  // Health Products
  {
    id: 6,
    name: "Smart Fitness Watch",
    price: 735,
    originalPrice: 1099,
    image: "https://readdy.ai/api/search-image?query=Modern%20smart%20fitness%20watch%20with%20sleek%20black%20band%20and%20vibrant%20AMOLED%20display%20showing%20health%20metrics%20on%20minimalist%20white%20surface%20with%20clean%20studio%20lighting%20showcasing%20advanced%20technology&width=400&height=400&seq=prod6health&orientation=squarish",
    category: "health",
    badge: "NEW",
    description: "Advanced fitness tracker with heart rate monitoring, GPS, sleep tracking, and 50+ workout modes with 7-day battery life. Water resistant to 50m.",
    rating: 4.8,
    reviews: 567,
    specs: { "Display": "AMOLED 1.4\"", "Battery": "7 days", "Water Resistance": "50m", "GPS": "Built-in", "Sensors": "HR, SpO2, Stress" }
  },
  {
    id: 7,
    name: "Massage Gun Pro",
    price: 479,
    originalPrice: 729,
    image: "https://readdy.ai/api/search-image?query=Professional%20massage%20gun%20device%20with%20ergonomic%20design%20multiple%20attachments%20and%20sleek%20black%20finish%20on%20clean%20white%20surface%20showcasing%20health%20wellness%20recovery%20equipment&width=400&height=400&seq=prod7health&orientation=squarish",
    category: "health",
    badge: "HOT",
    description: "Deep tissue percussion massage gun with 30 speed levels, 6 massage heads, and quiet brushless motor for muscle recovery. 6-hour battery life.",
    rating: 4.7,
    reviews: 334,
    specs: { "Speed Levels": "30", "Attachments": "6 heads", "Battery": "6 hours", "Noise": "&lt;45dB", "Weight": "1.1kg" }
  },
  {
    id: 8,
    name: "Smart Blood Pressure Monitor",
    price: 295,
    originalPrice: 439,
    image: "https://readdy.ai/api/search-image?query=Digital%20smart%20blood%20pressure%20monitor%20with%20LCD%20display%20and%20smartphone%20connectivity%20on%20white%20medical%20background%20showing%20health%20monitoring%20technology%20device&width=400&height=400&seq=prod8health&orientation=squarish",
    category: "health",
    badge: "SALE",
    description: "FDA-approved digital blood pressure monitor with Bluetooth connectivity, irregular heartbeat detection, and mobile app. Stores 120 readings.",
    rating: 4.6,
    reviews: 212,
    specs: { "Approval": "FDA Cleared", "Memory": "120 readings", "Connectivity": "Bluetooth 5.0", "Cuff Size": "22-42cm", "Display": "LCD" }
  },
  {
    id: 9,
    name: "Premium Wireless Earbuds",
    price: 295,
    originalPrice: 479,
    image: "https://readdy.ai/api/search-image?query=Premium%20wireless%20earbuds%20with%20sleek%20black%20metallic%20charging%20case%20and%20ergonomic%20design%20on%20minimalist%20white%20surface%20with%20soft%20lighting%20showcasing%20modern%20audio%20technology&width=400&height=400&seq=prod9health&orientation=squarish",
    category: "health",
    badge: "SALE",
    description: "Active noise cancelling earbuds with 8-hour battery life, IPX7 waterproof rating perfect for workouts and sports. 32-hour total with case.",
    rating: 4.8,
    reviews: 489,
    specs: { "Battery": "8h + 24h case", "ANC": "Active Noise Cancelling", "Water": "IPX7", "Connectivity": "Bluetooth 5.3", "Drivers": "11mm" }
  },
  {
    id: 10,
    name: "Yoga Mat Premium",
    price: 185,
    originalPrice: 279,
    image: "https://readdy.ai/api/search-image?query=Premium%20non-slip%20yoga%20mat%20in%20vibrant%20teal%20color%20rolled%20out%20on%20clean%20wooden%20floor%20with%20yoga%20blocks%20and%20water%20bottle%20showing%20fitness%20wellness%20lifestyle%20accessories&width=400&height=400&seq=prod10health&orientation=squarish",
    category: "health",
    badge: "NEW",
    description: "6mm thick non-slip yoga mat with alignment lines, eco-friendly TPE material, and carrying strap. Perfect for yoga, pilates, and stretching.",
    rating: 4.7,
    reviews: 156,
    specs: { "Thickness": "6mm", "Material": "Eco TPE", "Size": "183cm x 61cm", "Non-Slip": "Both sides", "Weight": "1.5kg" }
  },

  // Kitchen Products
  {
    id: 11,
    name: "Stainless Steel Cookware Set",
    price: 549,
    originalPrice: 849,
    image: "https://readdy.ai/api/search-image?query=Premium%20stainless%20steel%20cookware%20pots%20and%20pans%20with%20polished%20metallic%20finish%20and%20glass%20lids%20on%20clean%20white%20surface%20showing%20kitchen%20essentials%20collection&width=400&height=400&seq=prod11kitchen&orientation=squarish",
    category: "kitchen",
    badge: "HOT",
    description: "10-piece professional stainless steel cookware set with tri-ply construction, stay-cool handles, and oven-safe design up to 260°C.",
    rating: 4.9,
    reviews: 278,
    specs: { "Pieces": "10", "Material": "Tri-ply Stainless Steel", "Oven Safe": "Up to 260°C", "Dishwasher": "Safe", "Induction": "Compatible" }
  },
  {
    id: 12,
    name: "Portable Coffee Maker",
    price: 259,
    originalPrice: 379,
    image: "https://readdy.ai/api/search-image?query=Sleek%20portable%20espresso%20coffee%20maker%20with%20stainless%20steel%20finish%20and%20compact%20design%20on%20clean%20white%20countertop%20showcasing%20modern%20kitchen%20appliance%20technology&width=400&height=400&seq=prod12kitchen&orientation=squarish",
    category: "kitchen",
    badge: "NEW",
    description: "Portable espresso maker with manual pressure pump, makes rich crema coffee anywhere, perfect for travel and camping. No electricity needed.",
    rating: 4.6,
    reviews: 198,
    specs: { "Pressure": "18 bar", "Capacity": "80ml", "Weight": "400g", "Material": "BPA-Free", "Power": "Manual" }
  },
  {
    id: 13,
    name: "Smart Kitchen Scale",
    price: 149,
    originalPrice: 219,
    image: "https://readdy.ai/api/search-image?query=Digital%20smart%20kitchen%20scale%20with%20sleek%20glass%20surface%20and%20LED%20display%20showing%20precise%20measurements%20on%20white%20countertop%20with%20fresh%20ingredients%20background&width=400&height=400&seq=prod13kitchen&orientation=squarish",
    category: "kitchen",
    badge: "SALE",
    description: "Digital food scale with nutritional calculator, Bluetooth app connectivity, and precise measurements up to 5kg. Includes tare function.",
    rating: 4.5,
    reviews: 143,
    specs: { "Capacity": "5kg", "Precision": "1g", "Connectivity": "Bluetooth", "Display": "LED", "Battery": "AAA x 2" }
  },
  {
    id: 14,
    name: "Kitchen Organizer Set",
    price: 185,
    originalPrice: 289,
    image: "https://readdy.ai/api/search-image?query=Modern%20kitchen%20organizer%20storage%20containers%20and%20drawer%20dividers%20neatly%20arranged%20on%20clean%20white%20countertop%20showcasing%20organization%20solutions%20and%20space-saving%20accessories&width=400&height=400&seq=prod14kitchen&orientation=squarish",
    category: "kitchen",
    badge: "HOT",
    description: "Complete kitchen organization system with airtight containers, drawer dividers, and labels for pantry and cabinet storage. 24-piece set.",
    rating: 4.7,
    reviews: 267,
    specs: { "Pieces": "24", "Material": "BPA-Free Plastic", "Airtight": "Yes", "Dishwasher": "Safe", "Labels": "Included" }
  },
  {
    id: 15,
    name: "Air Fryer 5.5L",
    price: 399,
    originalPrice: 599,
    image: "https://readdy.ai/api/search-image?query=Modern%20digital%20air%20fryer%20with%20large%20capacity%20basket%20and%20sleek%20black%20design%20on%20clean%20kitchen%20countertop%20with%20fresh%20vegetables%20showing%20healthy%20cooking%20appliance&width=400&height=400&seq=prod15kitchen&orientation=squarish",
    category: "kitchen",
    badge: "HOT",
    description: "5.5L digital air fryer with 12 preset cooking modes, touch screen display, and rapid air circulation technology. 80% less oil than traditional frying.",
    rating: 4.8,
    reviews: 389,
    specs: { "Capacity": "5.5L", "Power": "1800W", "Presets": "12 modes", "Temperature": "80-200°C", "Timer": "60 min" }
  },

  // Electronics Products
  {
    id: 16,
    name: "Wireless Charging Pad",
    price: 149,
    originalPrice: 229,
    image: "https://readdy.ai/api/search-image?query=Sleek%20wireless%20charging%20pad%20with%20soft%20LED%20glow%20and%20minimalist%20design%20on%20clean%20white%20desk%20surface%20with%20smartphone%20charging%20showing%20modern%20technology%20accessory&width=400&height=400&seq=prod16elec&orientation=squarish",
    category: "electronics",
    badge: "NEW",
    description: "15W fast wireless charging pad compatible with all Qi-enabled devices. Charges through cases up to 5mm thick. LED indicator and foreign object detection.",
    rating: 4.6,
    reviews: 234,
    specs: { "Power": "15W max", "Standard": "Qi", "Compatibility": "Universal", "Cable": "USB-C included", "LED": "Indicator" }
  },
  {
    id: 17,
    name: "Smart Home Hub",
    price: 549,
    originalPrice: 799,
    image: "https://readdy.ai/api/search-image?query=Modern%20smart%20home%20hub%20device%20with%20sleek%20cylindrical%20design%20and%20ambient%20LED%20ring%20on%20clean%20white%20surface%20showing%20connected%20home%20technology%20and%20voice%20assistant&width=400&height=400&seq=prod17elec&orientation=squarish",
    category: "electronics",
    badge: "HOT",
    description: "Control all your smart home devices with one hub. Compatible with 10,000+ devices, supports voice commands, and has built-in Zigbee and Z-Wave.",
    rating: 4.7,
    reviews: 178,
    specs: { "Protocols": "Zigbee, Z-Wave, WiFi", "Devices": "10,000+ compatible", "Voice": "Alexa, Google", "Connectivity": "WiFi 6", "App": "iOS & Android" }
  },
  {
    id: 18,
    name: "Portable Power Bank 20000mAh",
    price: 219,
    originalPrice: 329,
    image: "https://readdy.ai/api/search-image?query=Slim%20portable%20power%20bank%20with%2020000mAh%20capacity%20and%20multiple%20charging%20ports%20in%20sleek%20black%20design%20on%20white%20surface%20showing%20mobile%20charging%20technology%20accessory&width=400&height=400&seq=prod18elec&orientation=squarish",
    category: "electronics",
    badge: "SALE",
    description: "20000mAh power bank with 65W PD fast charging, charges laptops and phones simultaneously. 3 outputs and 2 inputs. LED display shows exact battery level.",
    rating: 4.8,
    reviews: 456,
    specs: { "Capacity": "20000mAh", "Max Output": "65W PD", "Ports": "3 out, 2 in", "Display": "LED %", "Weight": "420g" }
  },
  {
    id: 19,
    name: "Mechanical Keyboard",
    price: 479,
    originalPrice: 699,
    image: "https://readdy.ai/api/search-image?query=Premium%20mechanical%20keyboard%20with%20RGB%20backlight%20and%20compact%20tenkeyless%20design%20on%20clean%20desk%20surface%20with%20vibrant%20colorful%20keycaps%20showing%20gaming%20productivity%20setup&width=400&height=400&seq=prod19elec&orientation=squarish",
    category: "electronics",
    badge: "NEW",
    description: "TKL mechanical keyboard with Cherry MX switches, per-key RGB lighting, and aluminum frame. Wireless and wired modes with 3000mAh battery.",
    rating: 4.9,
    reviews: 312,
    specs: { "Layout": "TKL 87-key", "Switch": "Cherry MX Red", "Backlight": "Per-key RGB", "Battery": "3000mAh", "Connection": "Wireless/USB-C" }
  },
  {
    id: 20,
    name: "4K Webcam",
    price: 365,
    originalPrice: 549,
    image: "https://readdy.ai/api/search-image?query=Professional%204K%20webcam%20with%20autofocus%20and%20privacy%20cover%20mounted%20on%20monitor%20in%20clean%20home%20office%20setup%20showing%20video%20conferencing%20technology%20device&width=400&height=400&seq=prod20elec&orientation=squarish",
    category: "electronics",
    badge: "HOT",
    description: "4K 30fps webcam with AI-powered autofocus, built-in noise-cancelling microphone, and privacy shutter. Plug-and-play for Windows and Mac.",
    rating: 4.7,
    reviews: 198,
    specs: { "Resolution": "4K 30fps", "FOV": "90°", "Autofocus": "AI-powered", "Mic": "Dual noise-cancelling", "Compatibility": "Windows/Mac" }
  }
];

export const featuredProducts = allProducts.slice(0, 12);

export const testimonials = [
  {
    id: 1,
    name: "Sarah Al-Mansouri",
    role: "Verified Buyer",
    image: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20happy%20smiling%20woman%20with%20natural%20makeup%20and%20casual%20attire%20on%20soft%20neutral%20background%20showing%20satisfied%20customer%20expression&width=100&height=100&seq=test1&orientation=squarish",
    rating: 5,
    text: "Absolutely love my purchases from AiShopio! The quality exceeded my expectations and delivery was super fast to Dubai Marina. The skincare products are amazing!"
  },
  {
    id: 2,
    name: "Mohammed Al-Rashid",
    role: "Verified Buyer",
    image: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20confident%20smiling%20man%20with%20casual%20business%20attire%20on%20soft%20neutral%20background%20showing%20satisfied%20customer%20expression&width=100&height=100&seq=test2&orientation=squarish",
    rating: 5,
    text: "Best online shopping experience in UAE! The kitchen accessories I ordered are top-notch quality. Cash on delivery made it so convenient. Customer service is exceptional!"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    role: "Verified Buyer",
    image: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20cheerful%20smiling%20young%20woman%20with%20modern%20style%20on%20soft%20neutral%20background%20showing%20happy%20customer%20expression&width=100&height=100&seq=test3&orientation=squarish",
    rating: 5,
    text: "I'm so impressed with the variety and quality. The fitness watch I bought works perfectly and the price in AED was unbeatable. Delivered to Abu Dhabi in 2 days!"
  },
  {
    id: 4,
    name: "David Thompson",
    role: "Verified Buyer",
    image: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20smiling%20middle-aged%20man%20with%20casual%20attire%20on%20soft%20neutral%20background%20showing%20satisfied%20customer%20expression&width=100&height=100&seq=test4&orientation=squarish",
    rating: 5,
    text: "Great products at competitive prices! The massage gun has been a game-changer for my recovery routine. Fast shipping and excellent packaging. WhatsApp support is brilliant!"
  }
];

export const categories = [
  { id: 1, name: "Beauty & Skincare", icon: "ri-magic-line", count: 150, key: "beauty" },
  { id: 2, name: "Kitchen Essentials", icon: "ri-restaurant-line", count: 200, key: "kitchen" },
  { id: 3, name: "Health & Wellness", icon: "ri-heart-pulse-line", count: 120, key: "health" },
  { id: 4, name: "Electronics", icon: "ri-smartphone-line", count: 180, key: "electronics" }
];
